import { BridgeForm } from './form/BridgeForm'
import { useState } from 'react'
import { BridgeViewProps } from '@/features/bridge/logic/types'

export function BridgePanel(props: BridgeViewProps) {
  const { bridge } = props
  const [errorMessage, setErrorMessage] = useState<string>('')

  return (
    <div className="w-full max-w-xl">
      <BridgeForm {...bridge} setErrorMessage={setErrorMessage} />

      {!!errorMessage && <div className="mt-2 text-center text-red-300 text-sm">{errorMessage}</div>}
    </div>
  )
}
